<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Offer Redemption Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :multiple="true"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-7 align-self-center mb-3" v-if="false">
            <div class="d-flex align-items-center justify-content-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                          ✖
                        </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  >
                  </Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <b-form-radio :value="'N'" class="j-radio" v-model="is_show_date">
                <div>
                  <span>{{ "Trx. Date" }}</span>
                </div>
              </b-form-radio>
              <strong class="mx-3">OR</strong>

              <b-form-radio :value="'Y'" class="j-radio" v-model="is_show_date">
                <div>
                  <span>{{ "Show Date" }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <b-form-input
                v-debounce:500="getOfferRedemptionReport"
                v-model="searchValue"
                placeholder="Search Offer Name"
              />
              <label :class="searchValue ? 'active' : ''">{{
                "Search Offer Name"
              }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedOfferName.length ? 'shift-up' : ''">{{
                $t("Select Offer Name")
              }}</label>
              <multiselect
                v-model="selectedOfferName"
                :options="allOfferNames"
                track-by="offer_setting_id"
                label="offer_title"
                :disabled="isRoleID"
                :searchable="true"
                placeholder=""
                :multiple="true"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedSalesChannels.length ? 'shift-up' : ''">{{
                $t("Select Sales Channel")
              }}</label>
              <multiselect
                :disabled="isRoleID"
                :options="allBookingsources"
                v-model="selectedSalesChannels"
                placeholder=""
                track-by="bs_id"
                label="bs_source"
                :searchable="true"
                :multiple="true"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getOfferRedemptionReport('N', 'N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="offerRedemptionRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getOfferRedemptionReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getOfferRedemptionReport('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Sr No.</th>
            <th>Cinema Name</th>
            <th>Movie Title</th>
            <th>Show Date and Time</th>
            <th>Transaction Date and Time</th>
            <th>Booking Number</th>
            <th>Auth Code</th>
            <th>Food Item</th>
            <th>Seat Number</th>
            <th>Seat Type</th>
            <th>Amount</th>
            <th>Total Qty</th>
            <th>Discount</th>
            <th>Offer Name</th>
            <th>Customer Email</th>
            <th>Customer Name</th>
            <th>Mobile Number</th>
            <th>Cashier Name</th>
            <th>Approved By</th>
            <th>Sales channel</th>
            <th>Merchant Id</th>
            <th>Card No</th>
            <th>Offer Remarks</th>
            <th>BO Remarks</th>
            <th>Fnb Remarks</th>
          </thead>
          <tbody v-if="offerRedemptionRecords.length > 0">
            <tr
              v-for="(
                transactionObj, transactionIndex
              ) in offerRedemptionRecords"
              :key="transactionIndex"
              class=""
            >
              <td class="text-right">{{ transactionIndex + 1 }}</td>
              <td class="text-left">{{ transactionObj.cinema_name }}</td>
              <td class="text-left">{{ transactionObj.movie_title }}</td>
              <td class="text-left">{{ transactionObj.show_date_and_time }}</td>
              <td class="text-left">
                {{ transactionObj.transaction_date_time }}
              </td>
              <td class="text-left">{{ transactionObj.booking_number }}</td>
              <td class="text-left">{{ transactionObj.bank_ref_no }}</td>
              <td class="text-left">{{ transactionObj.item_name || "-" }}</td>
              <td class="text-left">{{ transactionObj.seat_number }}</td>
              <td class="text-left">{{ transactionObj.seat_type_name }}</td>
              <td class="text-right">
                {{ currFormat(transactionObj.amount) }}
              </td>
              <td class="text-right">{{ transactionObj.total_quantity }}</td>
              <td class="text-right">
                {{ currFormat(transactionObj.discount) }}
              </td>
              <td class="text-left">{{ transactionObj.offer_name || "-" }}</td>
              <td class="text-left">
                {{ transactionObj.email || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.customer_name || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.mobile_number || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.cashier_name || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.authorized_by || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.bs_source || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.merchant_id || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.card_no || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.offer_comment || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.bo_trx_remarks || "-" }}
              </td>
              <td class="text-left">
                {{ transactionObj.ft_trx_remarks || "-" }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="text-left" colspan="10">Grand Total</td>
              <td class="text-right">{{ currFormat(grandTotal.amount) }}</td>
              <td class="text-right">{{ grandTotal.quantity }}</td>
              <td class="text-right">{{ currFormat(grandTotal.discount) }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      is_show_date: "N",
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: [],
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      offerRedemptionRecords: [],
      searchValue: "",
      excelFilePath: "",
      grandTotal: {},
      offerNames: [],
      selectedOfferName: [],
      selectedSalesChannels: [],
      allBookingsources: [],
      salesChannels: [],
      allOfferNames: [],
      allSalesChanalles: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: RawMaterialSupplierWise,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.getOfferRedemptionReport("N", "N", "filter");
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getOfferRedemptionReport(isExcel = "N", isPdf = "N", type = "") {
      this.offerRedemptionRecords = [];
      let role_is_cinema_level = this.secureStore.get("USINFO").cinema_id;
      if (role_is_cinema_level && !this.dropDown.selectedCinema.length) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }

      let loader = this.$loading.show();
      let payload = {
        cinema_id:
          this.dropDown.selectedCinema && this.dropDown.selectedCinema.length
            ? this.dropDown.selectedCinema.map((cinemasObj) => {
                return cinemasObj.cine_id;
              })
            : [],
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address:
          (this.dropDown.selectedCinema &&
            this.dropDown.selectedCinema.hasOwnProperty("cine_address") &&
            this.dropDown.selectedCinema.cine_address) ||
          "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        searchOffer: this.searchValue,
        is_show_date: this.is_show_date || "N",
        isExcel,
        isPdf,
      };

      if (type == "filter") {
        payload["type"] = "filter";
      }

      if (this.selectedOfferName.length) {
        payload["selectedOfferName"] = this.selectedOfferName.map(
          (offerObj) => {
            return offerObj.offer_title;
          }
        );
      }

      if (this.selectedSalesChannels.length) {
        payload["selectedSalesChannels"] = this.selectedSalesChannels.map(
          (offerObj) => {
            return offerObj.bs_id;
          }
        );
      }
      ReportsService.GetOfferRedemptionReport(payload)
        .then((response) => {
          const { data } = response;
          // console.log(data, "rajat");
          if (!data.status) return this.$toasted.show(data.message);

          if (type == "filter") {
            this.allOfferNames = [...data.offerNamesData];
            this.allBookingsources = [...data.bookingSourceData];
          } else {
            this.offerRedemptionRecords = [...data.Records];
            // this.getOfferNames();
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          }

          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
  watch: {
    fromDate() {
      this.getOfferRedemptionReport("N", "N", "filter");
    },
    toDate() {
      this.getOfferRedemptionReport("N", "N", "filter");
    },
  },
};
</script>

<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.no-wrap-table {
  white-space: initial !important;
}

/* .swc-report-table td {
  white-space: nowrap;
} */
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/offerRedemptionReport.vue